import { Grid, Typography } from '@material-ui/core';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from 'src/common/components/base-button';
import { ISidebarButton } from 'src/common/interfaces/dtos/ISidebarButton';
import { useResponsiveContext } from 'src/home-page/hooks/responsive-context';
import { styles } from './sidebar-styles';

const SidebarButton: React.FC<ISidebarButton> = ({
  isSelected,
  text,
  handleClick,
  isDisabled,
  buttonIcon: PassedIcon = LayersOutlinedIcon,
  buttonType = 'white',
  buttonGroup,
  isSubCategory,
  showIcon,
}: ISidebarButton): JSX.Element | null => {
  const classes = styles();
  const { t } = useTranslation();
  const { showSidebar } = useResponsiveContext();

  let defaultButtonClass = classes.button;
  if (isSelected) {
    defaultButtonClass += ` ${classes.buttonSelected}`;
  }

  text = t(text);

  return (
    <Grid>
      <BaseButton
        data-testid={`sidebar-button-${text.replace(/\s/g, '-').toLowerCase()}`}
        onClick={(): void => handleClick()}
        disabled={isDisabled}
        buttonType={buttonType}
        classes={{
          root: defaultButtonClass,
          startIcon: classes.buttonStartIcon,
          label: !showIcon && !showSidebar ? classes.buttonLabelSmallForm : classes.buttonLabel,
        }}
        startIcon={isSubCategory || !showIcon ? null : <PassedIcon />}
      >
        <Typography
          className={!showIcon && !showSidebar ? classes.buttonTextSmallForm : classes.buttonText}
        >
          {text}
        </Typography>
        {buttonGroup && <Grid className={classes.nevigateIcon} />}
      </BaseButton>
    </Grid>
  );
};

export default SidebarButton;
